import { Chip } from '@mui/material';
import { OfferOrderStatusDto } from 'src/dtos';
import { OfferOrderStatus } from 'src/models';
import { ColorConstant } from 'src/styles';

const getOfferOrderStatusTagPalette = (type: OfferOrderStatusDto): { background: string; color: string } => {
  let backgroundColor;
  let color;

  switch (type) {
    case OfferOrderStatusDto.PendingFunds:
      backgroundColor = ColorConstant.GRAY3;
      color = ColorConstant.GRAY7;
      break;
    case OfferOrderStatusDto.PendingOfferClose:
      backgroundColor = ColorConstant.ORANGE1;
      color = ColorConstant.GRAY8;
      break;
    case OfferOrderStatusDto.PendingAction:
      backgroundColor = ColorConstant.BRAND1;
      color = ColorConstant.BRAND7;
      break;
    case OfferOrderStatusDto.Approved:
      backgroundColor = ColorConstant.BRAND2;
      color = ColorConstant.BRAND7;
      break;
    case OfferOrderStatusDto.Complete:
      backgroundColor = ColorConstant.GREEN2;
      color = ColorConstant.GREEN7;
      break;
    case OfferOrderStatusDto.PendingFirmCancellation:
      backgroundColor = ColorConstant.ORANGE1;
      color = ColorConstant.ORANGE7;
      break;
    case OfferOrderStatusDto.Cancelled:
      backgroundColor = ColorConstant.ORANGE2;
      color = ColorConstant.ORANGE7;
      break;
    case OfferOrderStatusDto.Rejected:
      backgroundColor = ColorConstant.RED2;
      color = ColorConstant.RED7;
      break;
    case OfferOrderStatusDto.Deleted:
      backgroundColor = ColorConstant.RED2;
      color = ColorConstant.RED8;
      break;
  }

  return { background: backgroundColor, color };
};

interface OfferOrderStatusChipProps {
  value: OfferOrderStatus;
}

export const OfferOrderStatusChip = ({ value }: OfferOrderStatusChipProps) => {
  return <Chip sx={getOfferOrderStatusTagPalette(value.value)} label={value.label} />;
};
